/**
 * Disable console logs in production to prevent security leaks
 * This should be imported at the very top of index.js
 * 
 * Security Benefits:
 * - Prevents leaking of user emails, auth tokens, API responses
 * - Hides internal application logic and data flow
 * - Reduces attack surface by not exposing system details
 */

if (process.env.NODE_ENV === 'production') {
  // Store original console for emergency debugging (accessible via window._console in browser)
  window._console = {
    log: console.log,
    warn: console.warn,
    error: console.error,
    info: console.info,
    debug: console.debug
  };
  
  // Replace all console methods with empty functions
  const noop = () => {};
  
  console.log = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.table = noop;
  console.group = noop;
  console.groupEnd = noop;
  console.groupCollapsed = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.timeLog = noop;
  console.count = noop;
  console.countReset = noop;
  console.clear = noop;
  
  // Keep console.error but sanitize it to prevent sensitive data leaks
  console.error = (...args) => {
    // In production, only log generic error without details
    if (window.location.hostname !== 'localhost') {
      // Do nothing - completely silent in production
      return;
    }
  };
  
  // Log that console is disabled (only once)
  console.log('Console logging is disabled in production mode');
}
